<div class="schedule-wrapper">
  <ng-container
    *ngFor="let siteHaulerContractDocument of siteHaulerContractDocuments">
    <div *ngIf="siteHaulerContractDocument.agreementDocuments.length > 0">
      <div
        class="row brdbottom cursor"
        (click)="showContractDocument(siteHaulerContractDocument.name)">
        <div class="col equipment-type-text">
          {{ siteHaulerContractDocument.haulerName }}
        </div>
        <div class="col">
          <mat-icon
            fontIcon="{{
              activeAgreement == siteHaulerContractDocument.name
                ? 'expand_less'
                : 'expand_more'
            }}"
            *ngIf="
              siteHaulerContractDocument.agreementDocuments &&
              siteHaulerContractDocument.agreementDocuments.length > 0
            ">
          </mat-icon>
        </div>
      </div>
      <div *ngIf="activeAgreement == siteHaulerContractDocument.name">
        <div
          class="row pddbottom"
          *ngFor="
            let contractDocument of siteHaulerContractDocument.agreementDocuments
          ">
          <div class="col equipment-type-text">
            {{ contractDocument.documentName }}
          </div>
          <div class="col equipment-type-text">
            {{ contractDocument.documentCreatedTime | date: 'MM/dd/yyyy' }}
          </div>
          <div class="col equipment-type-text cursor">
            <a
              (click)="
                downloadFile(
                  contractDocument.documentId,
                  contractDocument.documentName
                )
              ">
              <img src="../assets/images/download.svg" alt="download" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
